import React from "react";
import { $t } from '@/modules/i18n';

class Contact extends React.Component {
  render() {
    const msg = this.props.Message;
    return (
      <section id="contact">
        <div className="container text-center">
          <div className="title-block">
            <h4>{$t(msg.contactDesc01)}</h4>
            <h4>{$t(msg.contactDesc02)} <a href={"mailto:" + msg.contactEmail} target="_blank" rel="noopener noreferrer">{msg.contactEmail}</a>{"!"}</h4>
            <a href={"mailto:" + msg.contactEmail} className="btn btn-primary" style={{ margin: "30px 0" }} target="_blank" rel="noopener noreferrer">{$t(msg.contactBtn)}</a>
            <div className="note" style={{ textAlign: "left" }}>
            </div>
          </div>
        </div>

        <img src={require('@uh/assets/images/rightdoublearrow.png')} alt="arrowGraphic" className="right-double-arrow" />
        <img src={require('@uh/assets/images/leftdoublearrow.png')} alt="arrowGraphic" className="left-double-arrow" />
      </section>
    );
  }
}
export default Contact;
